<template>
  <el-dialog :visible.sync="dialogVisible" custom-class="custom-dialog" class="recommend-dialog" :close-on-click-modal="false" append-to-body width="650px">
    <div slot="title" class="title">
      <div class="title-name">大神是如何填写的<span class="title-btn" @click="copy">可复制</span></div>
      <div class="side-title"></div>
      <div class="dialog-close-btn" @click="dialogVisible = false">X</div>
    </div>
    <div v-if="template[type] && template[type].length > 1" class="text-right">
      <el-button type="text" size="mini" @click="nextOne">换一个</el-button>
    </div>
    <div v-if="template[type] && template[type][index]">
      <div v-if="template[type][index].title" style="color:#000">{{ template[type][index].title }}</div>
      <pre>{{ template[type] && template[type][index].content }}</pre>
    </div>
    <div v-else>暂无</div>
  </el-dialog>
</template>
<script>

export default {
  data() {
    return {
      dialogVisible: false,
      type:'',
      template: {
        一句话介绍:[
          {
            title:'',
            content:`国内公募基金领域排名前五的公司
一家业内口碑极好，投研和销售综合发展，规模稳定排名前3市场化公募基金
麦子店高盛，连续十年蝉联券商第一
继华兴之后市场最有影响力的新兴顶尖FA平台，是行业人效最高、客户口碑最好的一级市场投行
市场顶尖合资券商或头部券商，致力于建设为中国国际级航母券商`
          }
        ],
        公司介绍:[
          {
            title:'',
            content:`泰康资产成立于2006年，前身为泰康人寿保险股份有限公司资产管理中心，泰康资产具有丰富的多领域资产配置经验，投资范围涵盖固定收益投资、权益投资、境外投资、基础设施及不动产投资、股权投资、金融产品投资等，所提供的服务和产品包括保险资金投资管理、另类项目投资管理、企业年金投资管理、金融同业业务、财富管理服务、资产管理产品、养老金产品、境外理财产品等。2015年4月，泰康资产公募基金管理业务资格正式获得监管机构批准，成为首家获得该业务资格的保险资产管理公司。`,
          }
        ],
        公司优势:[
          {
            title:'以某头部券商为例',
            content:`a．管理层：搞定政府资源；
b．投行业务策略：行业组深耕*国央企及新经济同时覆盖区域下沉；
c．非常有竞争力的薪酬优势，业内最高固薪券商之一，吸引到很多优秀人才；
d．品牌建设和宣传到位，员工和出去的人都很自豪，且外面的人都很向往这里“每个投行人都有一个XX梦”。`,
          },
          {
            title:'以某头部公募基金为例',
            content:`a.公司的投资研究队伍专业、稳健、勇于进取
b.业绩稳定，回报丰厚：完善的制度、严格的管理
c.研究主导，投研良性互动，研究主导的投资文化，注重深度挖掘、实地调研、持续跟踪`,
          }
        ],
        公司劣势:[
          {
            title:'',
            content:`固薪不算特别高，激励机制差，递延严重，体系相对是有些僵化的，内部高层较稳定，外招主要以SVP－D的中层＆VP及以下的执行层为主，很难在薪酬＼定位（管理）上有突破`,
          }
        ],
        '业务特点/人员风格':[
          {
            title:'以某FA为例',
            content:`a.发展很快，差异化是重点。 最早提出深度服务， 研究驱动的口号的FA。
b.核心:专业性， 行业认知比别人深刻。行业研究， 交易流程，理解更深，对人的要求就更高。
c.用人要求： 专业能力， 有方法论能研究透行业，对研究有热爱的人。
d.希望： 做最受尊重的投资银行。用自己的专业能力打动别人。
e.愿景：保持稳健的业务增长 ， 希望做国际化转。 做世界级的投行。
f.客户已经达到世界级的水平，已经积累的非常多的knowhow， 最新机构的商业模式等，希望带着knowhow实现国际化的战略目标。`,
          },
          {
            title:'以某头部公募基金为例',
            content:`a.股东方比较分散，最高的股东占比也就20多，所以管理层可以稳定长期自主经营；管理层又都很专业
b.构建起一套稳定，专业的投研和市场体系；业务线完整，均衡发展，多点开花。
c.投研氛围好，长期主义，包容度高，并不是短期考核，不追涨杀跌，不追热点，鼓励大家专注于自己的某一块
d.团队稳定性强：应届生毕业进入公司，注重内部培养，感情深厚。
e.同时设定了股权激励，平时奖金也非常丰厚，公司整体文化非常好，员工收入也高，稳定性强。`,
          }
        ],
      },
      index:0,
    }
  },
  methods: {
    open(type) {
      this.type = type
      if(!this.template[type]) return
      this.dialogVisible = true
      this.index = 0
    },
    nextOne() {
      this.index = this.template[this.type].length > this.index + 1 ? this.index + 1 : 0
    },
    copy(){
      try {
        const oTextarea = document.createElement('textarea')
        oTextarea.value = this.template[this.type][this.index].content
        if(!oTextarea.value) return
        document.body.appendChild(oTextarea)
        oTextarea.select()
        document.execCommand('Copy')
        document.body.removeChild(oTextarea)
        this.$message.success('复制成功')
      } catch (e) {
        console.log(e.message);
      }
    },
  },
}
</script>
<style>
.recommend-dialog .el-dialog__body {
  padding-top: 0px;
}
</style>
<style scoped src="../../statistics/css/commonCompany.css"></style>
<style scoped>
.recommend-content {
  display: flex;
  flex-direction: column;
}
.alert-box {
  padding: 10px 10px;
}
.edit-dialog-item {
  margin-bottom: 10px;
}
.recommend-title {
  font-size: 16px;
  font-weight: 600;
}
pre {
  white-space: pre-wrap;
  word-wrap: break-word;
  line-height:1.5;
  margin: 0;
  padding:15px
}
.title-btn {
  margin-left: 30px;
  color: #cbcbcb;
  font-size: 14px;
  cursor: pointer;
}
</style>
